import { css } from '@emotion/core';

export const DatetimeGlobalStyles = css`
  .DatetimeContainer {
    .rdtCounters {
      display: inline-flex;
      align-items: center;
      height: 258px;
    }
    .rdtCount,
    .rdtCounterSeparator {
      font-weight: normal;
    }
    .rdtCount {
      height: 25%;
    }
    .rdtBtn {
      color: #c9cbcd;
    }
    .rdtPicker {
      border: 2px solid rgba(201, 203, 205, 0.2);
      margin: 0;
      border-radius: 6px;
      width: 100%;
      padding: 0;
    }
    tfoot {
      border-top: 2px solid rgba(201, 203, 205, 0.2);
    }
    .rdtSwitch {
      font-size: 18px;
      padding: 14px;
    }
    .rdtPrev,
    .rdtNext {
      vertical-align: middle !important;
    }
    .rdtPrev span,
    .rdtNext span {
      color: #c9cbcd;
      font-size: 32px;
    }
    .rdtTimeToggle {
      font-size: 18px;
      padding: 10px;
    }
    .dow {
      font-weight: normal;
      font-size: 14px;
      color: #5f6369;
    }
    .rdtDay {
      font-weight: normal;
      font-size: 16px;
      height: 32px;
    }
    .rdtDay:hover {
      background: transparent;
    }
    .rdtMonth,
    .rdtYear {
      height: 86px;
    }
    .rdtActive {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      background: #5000b9 !important;
      border-radius: 100%;
      margin: auto;
      color: white;
      font-weight: bold;
    }
    .rdtDay.rdtActive {
      width: 30px;
      height: 30px;
    }
    .rdtMonth.rdtActive,
    .rdtYear.rdtActive {
      width: 60px;
      height: 60px;
      margin: 13px 0px 13px 17px;
    }
  }
`;
